import { render, staticRenderFns } from "./Redirect2Shop.vue?vue&type=template&id=072b2838&"
import script from "./Redirect2Shop.vue?vue&type=script&lang=js&"
export * from "./Redirect2Shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports